// removed by extract-text-webpack-plugin
module.exports = {"block":"subnavigation__block-3aOlW","container":"subnavigation__container-3aMSK","underlined":"subnavigation__underlined-3yJAS","item":"subnavigation__item-3Bsyp","isSelected":"subnavigation__isSelected-1FXId","isClickable":"subnavigation__isClickable-2mzbZ"};


//////////////////
// WEBPACK FOOTER
// ./packages/account-ui/subnavigation/subnavigation.css
// module id = 873
// module chunks = 0